require('./bootstrap');
require('./livewire_events');

window.Swal = require('sweetalert2');

// Alpine.js es manejado automáticamente por Livewire
// No importar manualmente para evitar conflictos


